/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { ModalService } from 'app/shared/services';
import { filter } from 'rxjs/operators';

@Component({
  selector: '[loginModalGeneral]',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent implements OnInit {
  @Input() showCreateAccount = false;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: ModalService, private router: Router) {}

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.close();
    });
  }

  close() {
    this.modalService.hideModal();
    this.closeModal.emit({});
  }

  showSignup() {
    this.closeModal.emit({ nextAction: 'showSignup' });
  }
}
